export default __webpack_public_path__ + "assets/models/d1ef502f22c8fe3562ea193253eb968a.glb";